import type { ApolloCache } from "@apollo/client/cache"

import { FloorTypename } from "shared/types/Project"

import {
  FloorCompleteFragment,
  FloorCompleteFragmentDoc
} from "entities/floors/graphql/fragments.generated"

export function readFloorCompleteFragment(
  id: string,
  cache: ApolloCache<object>
) {
  const cacheId = cache.identify({ id, __typename: FloorTypename })
  if (!cacheId) {
    return null
  }
  return cache.readFragment<FloorCompleteFragment>(
    {
      id: cacheId,
      fragmentName: "FloorComplete",
      fragment: FloorCompleteFragmentDoc
    },
    true
  )
}
